import { createFileRoute } from '@tanstack/react-router'
import { SettingsSection } from '@/components/sections/settings-section'
import { z } from '@spcc/core'

export const Route = createFileRoute('/settings')({
  validateSearch: (search) =>
    z.object({
      tab: z.enum(['profile', 'users', 'preferences']).optional(),
    }).parse(search),
  component: SettingsPage,
})

function SettingsPage() {
  const { tab } = Route.useSearch()
  return <SettingsSection initialTab={tab} />
}
